import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="container mx-auto p-6 max-w-4xl text-gray-800">
      <h1 className="text-3xl font-semibold mb-4">Terms and Conditions</h1>
      <p className="mb-4">
        These Terms and Conditions govern the use of our online platform
        designed for hospital management, human resource operations, and related
        enterprise solutions.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Use of Services</h2>
      <p className="mb-4">
        Users agree to use the platform solely for authorized business or
        institutional purposes. Each organization is responsible for maintaining
        account security and ensuring compliance with applicable laws and
        internal policies.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Subscriptions and Payments
      </h2>
      <p className="mb-4">
        The platform operates on a subscription basis. By subscribing, users
        authorize our payment partner (e.g., Razorpay, Stripe) to process
        payments securely. Subscriptions renew automatically unless cancelled
        prior to renewal.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Data Confidentiality</h2>
      <p className="mb-4">
        All patient, employee, and institutional data entered remains the
        property of the respective organization. The platform ensures secure
        handling and storage in compliance with data protection regulations.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Intellectual Property
      </h2>
      <p className="mb-4">
        All platform design, code, and trademarks remain the intellectual
        property of the development entity. Clients are granted a limited,
        non-transferable right to use the platform as per their subscription
        agreement.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Liability Limitation</h2>
      <p className="mb-4">
        The platform provider shall not be liable for indirect or consequential
        damages arising from service interruptions, system failures, or
        third-party dependencies.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Modifications</h2>
      <p className="mb-4">
        These Terms may be revised periodically to reflect updates in service
        offerings or compliance requirements. Continued use of the platform
        implies acceptance of the revised Terms.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Contact</h2>
      <p>
        For questions, please email{" "}
        <a href="mailto:admin@cheritto.com" className="text-blue-600 underline">
          admin@cheritto.com
        </a>
        .
      </p>
    </div>
  );
}
